import { defineMessages } from 'react-intl';

const messages = defineMessages({
  searchPlaceholder: {
    id: 'BrandListing.SearchPlaceholder',
    defaultMessage: 'Filter Within…',
  },
});

export default messages;
